type Props = {
    size?: number;
    fill?: string;
};

export function YAxisIcon(props: Props) {
    const { size = 40, fill = 'black' } = props;

    return (
        <svg
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13 14 L13 84 L87 84"
                stroke={fill}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <polygon points="13,4 5,19 21,19" fill={fill} />
            <text
                x="25"
                y="73"
                fontSize="32"
                fontStyle="italic"
                fontFamily="Georgia, 'Times New Roman', serif"
                fill={fill}
            >
                Y
            </text>
        </svg>
    );
}
